import {
  Badge,
  type ColumnGroup,
} from '@commenda/kakashi';

import { IndirectTaxFilingsHelper } from '../helpers';
import type { BreakdownLiabilityReportTableRow } from '../types';

export const BREAKDOWN_LIABILITY_REPORT_COLUMN_GROUPS: ColumnGroup<
  BreakdownLiabilityReportTableRow,
  unknown
>[] = [
    {
      id: 'liability-report-breakdown',
      columns: [
        {
          accessorKey: 'jurisdiction',
          header: 'Jurisdiction',
          title: 'Jurisdiction',
          cell: ({ row }) => (
            <span className="txt-small-medium text-text-primary">
              {row.original.jurisdiction}
            </span>
          ),
        },
        {
          accessorKey: 'formTitle',
          header: 'Return',
          title: 'Return',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-regular text-text-secondary max-w-[220px] truncate block">
              {row.original.formTitle}
            </span>
          ),
        },
        {
          accessorKey: 'filingPeriodLabel',
          header: 'Tax period',
          title: 'Tax period',
          enableSorting: false,
          cell: ({ row }) => (
            <Badge variant="warning" size="sm">
              {row.original.filingPeriodLabel}
            </Badge>
          ),
        },
        {
          accessorKey: 'dueDateLabel',
          header: 'Due date',
          title: 'Due date',
          enableSorting: false,
          cell: ({ row }) => (
            <Badge variant="success" size="sm">
              {row.original.dueDateLabel}
            </Badge>
          ),
        },
        {
          accessorKey: 'transactionsCount',
          header: 'Transactions',
          title: 'Transactions',
          enableSorting: false,
          cell: ({ row }) => (
            <Badge variant="blue" size="sm">
              {row.original.transactionsCount}
            </Badge>
          ),
        },
        {
          accessorKey: 'taxableAmount',
          header: 'Taxable amount',
          title: 'Taxable amount',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-regular text-text-primary">
              <span className="txt-extra-small-regular text-text-quaternary">
                {IndirectTaxFilingsHelper.getCurrencySymbol(row.original.currency)}{' '}
              </span>
              {IndirectTaxFilingsHelper.formatCurrency(row.original.taxableAmount)}
            </span>
          ),
        },
        {
          accessorKey: 'nonTaxableAmount',
          header: 'Non-taxable amount',
          title: 'Non-taxable amount',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-regular text-text-primary">
              <span className="txt-extra-small-regular text-text-quaternary">
                {IndirectTaxFilingsHelper.getCurrencySymbol(row.original.currency)}{' '}
              </span>
              {IndirectTaxFilingsHelper.formatCurrency(
                row.original.nonTaxableAmount
              )}
            </span>
          ),
        },
        {
          accessorKey: 'taxDue',
          header: 'Tax due',
          title: 'Tax due',
          enableSorting: false,
          cell: ({ row }) => (
            <span className="txt-small-medium text-text-primary">
              <span className="txt-extra-small-regular text-text-quaternary">
                {IndirectTaxFilingsHelper.getCurrencySymbol(row.original.currency)}{' '}
              </span>
              {IndirectTaxFilingsHelper.formatCurrency(row.original.taxDue)}
            </span>
          ),
        },
        {
          accessorKey: 'filingStatusUI',
          header: 'Filing status',
          title: 'Filing status',
          enableSorting: false,
          cell: ({ row }) => {
            const config = IndirectTaxFilingsHelper.getStatusBadgeConfig(
              row.original.filingStatusUI
            );
            return (
              <Badge variant={config.variant} size="sm">
                {config.label}
              </Badge>
            );
          },
        },
      ],
    },
  ];
